import * as getFlameSignalDataService from '../services/getFlameSignaGraphDataService'
import { flameSignalDataLoadingAction, flameSignalDataUpdateAction, flameSignalDataErrorAction } from './getFlameSignaGraphDataSlice'
import { flowSignalDataLoadingAction, flowSignalDataUpdateAction, flowSignalDataErrorAction } from './getFlowSignaGraphDataSlice'
import { type deviceInterface } from '../services/getFlameSignaGraphDataService'
import { SaveDefaultViewDataLoadingAction, SaveDefaultViewDataUpdateAction, SaveDefaultViewDataErrorAction, SaveDefaultViewDataReset } from './saveDefaultViewSlice'
import * as saveDefaultView from '../services/saveDeafultViewService'
import * as HealthScoreService from '../services/healthScoreService'
import { healthScoreLoadingAction, healthScoreUpdateAction, healthScoreErrorAction } from './healthScoreSlice'
import * as AssetAlarmService from '../services/assetAlarmService'
import { assetAlarmLoadingAction, assetAlarmUpdateAction, assetAlarmErrorAction } from './assetAlarmSlice'
import * as getHealthScoreService from '../services/getTotalHealthScoreService'
import { HealthScoreAssetLoadingAction, HealthScoreAssetUpdateAction, HealthScoreAssetErrorAction } from './getTotalHealthScoreSlice'
import * as getAssetPerformanceLineData from '../services/getAssetPerformanceRegisterData'
import * as getModbusRegisterGraphService from '../services/getModbusRegisterGraphService'
import { AssetPerformanceDataLoadingAction, AssetPerformanceDataUpdateAction, AssetPerformanceDataErrorAction } from './getAssetPerformanceDataSlice'
import * as getAssetPerformanceKPIData from '../services/getAssetPerformanceKPIData'
import { AssetPerformanceKPIDataLoadingAction, AssetPerformanceKPIDataUpdateAction, AssetPerformanceKPIDataErrorAction } from './getAssetPerformanceKPIDataSlice'
import * as getAlertCountDataService from '../services/getAlertCoutDataService'
import { AlertCountDataLoadingAction, AlertCountDataUpdateAction, AlertCountDataErrorAction } from './getAlertCountAssetDashbordSlice'
import * as getAlertTrendAssetKPIData from '../services/getAlertTrendAssetKPIData'
import { AlertTrendKPIDataLoadingAction, AlertTrendKPIDataUpdateAction, AlertTrendKPIDataErrorAction } from './getAlertTrendAssetKPIDataSlice'
import * as getAlertTrendRegisterData from '../services/getAlertTrendRegisterData'
import { AlertTrendRegisterDataLoadingAction, AlertTrendRegisterDataUpdateAction, AlertTrendRegisterDataErrorAction } from './getAlertTrendRegisterDataSlice'
import { parameterTreeErrorAction, parameterTreeLoadingAction, parameterTreeUpdateAction } from './parameterTreeSlice'
import * as MenuInfoService from '../../dashboard/services/menuInfoService'
import { flameRegisterGraphDataLoadingAction, flameRegisterGraphDataUpdateAction, flameRegisterGraphDataErrorAction } from './getFlameRegisterDataSlice'
import { flameKPIGraphDataLoadingAction, flameKPIGraphDataUpdateAction, flameKPIGraphDataErrorAction } from './getFlameKPIDataSlice'
import { flowRegisterGraphDataLoadingAction, flowRegisterGraphDataUpdateAction, flowRegisterGraphDataErrorAction } from './getFlowRegisterDataSlice'
import { flowKPIGraphDataLoadingAction, flowKPIGraphDataUpdateAction, flowKPIGraphDataErrorAction } from './getFlowKPIDataSlice'
import * as getAssetDashboardHeaderRegisterSummary from '../services/getAssetDashboardHeaderRegisterSummary'
import * as getAssetDashboardHeaderKPISummary from '../services/getAssetDashboardHeaderKPISummary'
import { HeaderSummaryAssetRegisterDataLoadingAction, HeaderSummaryAssetRegisterDataUpdateAction, HeaderSummaryAssetRegisterDataErrorAction } from './getAssetDashboardHeaderRegisterSummarySlice'
import { HeaderSummaryAssetKPIDataLoadingAction, HeaderSummaryAssetKPIDataUpdateAction, HeaderSummaryAssetKPIDataErrorAction } from './getAssetDashboardHeaderKPISummarySlice'

export const fetchflameSignalData = (siteId: string, assetId: string, cimCodeID: deviceInterface, startDateTime: string, endDateTime: string, graphName: string) => (dispatch: any) => {
  dispatch(flameSignalDataLoadingAction())
  void getFlameSignalDataService.getFlameSignaGraphData(
    siteId,
    assetId,
    cimCodeID,
    startDateTime,
    endDateTime,
    graphName,
    (flameSignalReadingData: any, httpStatus: any) => {
      dispatch(flameSignalDataUpdateAction({ data: flameSignalReadingData, httpStatus }))
    },
    // istanbul ignore next
    (errorMessage, httpStatus) => {
      dispatch(flameSignalDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchflowSignalData = (siteId: string, assetId: string, cimCodeID: deviceInterface, startDateTime: string, endDateTime: string, graphName: string) => (dispatch: any) => {
  dispatch(flowSignalDataLoadingAction())
  void getFlameSignalDataService.getFlameSignaGraphData(
    siteId,
    assetId,
    cimCodeID,
    startDateTime,
    endDateTime,
    graphName,
    (flowSignalReadingData: any, httpStatus: any) => {
      // istanbul ignore next
      dispatch(flowSignalDataUpdateAction({ data: flowSignalReadingData, httpStatus }))
    },
    // istanbul ignore next
    (errorMessage, httpStatus) => {
      dispatch(flowSignalDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const saveDefaultViewDataservice = (parentAssetId: string, requestParameter: any) => async (dispatch: any) => {
  dispatch(SaveDefaultViewDataLoadingAction())
  try {
    await saveDefaultView.SaveDefaultViewService(parentAssetId, requestParameter, (SaveDefaultViewData, httpStatus) => {
      dispatch(SaveDefaultViewDataUpdateAction({ data: SaveDefaultViewData.data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(SaveDefaultViewDataErrorAction({ errorMessage, httpStatus }))
    },
    () => {
      dispatch(SaveDefaultViewDataReset())
    }
    )
  } catch (e: any) {
    // istanbul ignore next
    dispatch(SaveDefaultViewDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getHealthScore = (siteId: string, assetId: string) => async (dispatch: any) => {
  dispatch(healthScoreLoadingAction())
  void HealthScoreService.fetchHealthScore(siteId, assetId,
    (data: any, httpStatus: number) => {
      dispatch(healthScoreUpdateAction({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(healthScoreErrorAction({ errorMessage, httpStatus }))
    })
}

export const getEnabledAlarmsbyLabel = (siteId: string, assetId: string, label: string, SortParams: string) => async (dispatch: any) => {
  dispatch(assetAlarmLoadingAction({ label }))
  void AssetAlarmService.fetchEnabledAlarmsbyLabel(siteId, assetId, label, SortParams,
    (data: any, httpStatus: number) => {
      dispatch(assetAlarmUpdateAction({ data, label, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(assetAlarmErrorAction({ errorMessage, httpStatus }))
    })
}

export const getHealthScoreAssetservice = (parentSiteId: string, parentAssetId: string) => async (dispatch: any) => {
  dispatch(HealthScoreAssetLoadingAction())
  try {
    await getHealthScoreService.getTotalHealthScoreAssetDashboard(parentSiteId, parentAssetId, (HealthScoreAssetDashboard, httpStatus) => {
      dispatch(HealthScoreAssetUpdateAction({ data: HealthScoreAssetDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(HealthScoreAssetErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(HealthScoreAssetErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getHeaderSummaryRegisterAssetDashboardService = (siteId: string, assetId: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(HeaderSummaryAssetRegisterDataLoadingAction())
  try {
    await getAssetDashboardHeaderRegisterSummary.getAssetDashboardHeaderRegisterSummary(siteId, assetId, graphName, requestParameter, isdefault, (headerSummaryAssetData, httpStatus) => {
      dispatch(HeaderSummaryAssetRegisterDataUpdateAction({ data: headerSummaryAssetData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(HeaderSummaryAssetRegisterDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(HeaderSummaryAssetRegisterDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getHeaderSummaryKPIAssetDashboardService = (siteId: string, assetId: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(HeaderSummaryAssetKPIDataLoadingAction())
  try {
    await getAssetDashboardHeaderKPISummary.getAssetDashboardHeaderKPISummary(siteId, assetId, graphName, requestParameter, isdefault, (headerSummaryAssetData, httpStatus) => {
      dispatch(HeaderSummaryAssetKPIDataUpdateAction({ data: headerSummaryAssetData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(HeaderSummaryAssetKPIDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(HeaderSummaryAssetKPIDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAssetPerformanceDataDashboardService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(AssetPerformanceDataLoadingAction())
  try {
    await getAssetPerformanceLineData.getAssetPerformanceLineData(startDate, endDate, graphName, requestParameter, isdefault, (AssetPerformanceLineData, httpStatus) => {
      dispatch(AssetPerformanceDataUpdateAction({ data: AssetPerformanceLineData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(AssetPerformanceDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(AssetPerformanceDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAssetPerformanceKPIDataDashboardService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(AssetPerformanceKPIDataLoadingAction())
  try {
    await getAssetPerformanceKPIData.getAssetPerformanceKPILineData(startDate, endDate, graphName, requestParameter, isdefault, (AssetPerformanceKPIData, httpStatus) => {
      // Filter out data points where execution_status is "Failure"
      const filteredData = {
        ...AssetPerformanceKPIData,
        deviceKPIReadings: AssetPerformanceKPIData.deviceKPIReadings.map((device: any) => ({
          ...device,
          kpiReadings: device.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        })),
        assetKPIReadings: AssetPerformanceKPIData.assetKPIReadings.map((asset: any) => ({
          ...asset,
          kpiReadings: asset.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        }))
      }

      dispatch(AssetPerformanceKPIDataUpdateAction({ data: filteredData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AssetPerformanceKPIDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AssetPerformanceKPIDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertCountDashboardService = (siteId: string, assetId: string, severity: string) => async (dispatch: any) => {
  dispatch(AlertCountDataLoadingAction())
  try {
    await getAlertCountDataService.getAssetAlertCountByAssetId(siteId, assetId, severity, (AlertCountDataAssetDashboard, httpStatus) => {
      dispatch(AlertCountDataUpdateAction({ data: AlertCountDataAssetDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AlertCountDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertCountDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertTrendKPIDataDashboardService = (startDate: string, endDate: string, graphName: string, requestParameter: any, intervalGroup: string, isdefault: boolean) => async (dispatch: any) => {
  dispatch(AlertTrendKPIDataLoadingAction())
  try {
    await getAlertTrendAssetKPIData.getAlertTrendKPIAssetDashboardData(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault, (AlertTrendKPIDataAssetDashboard, httpStatus) => {
      dispatch(AlertTrendKPIDataUpdateAction({ data: AlertTrendKPIDataAssetDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AlertTrendKPIDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertTrendKPIDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertTrendRegisterDataDashboardService = (startDate: string, endDate: string, graphName: string, requestParameter: any, intervalGroup: string, isdefault: boolean) => async (dispatch: any) => {
  dispatch(AlertTrendRegisterDataLoadingAction())
  try {
    await getAlertTrendRegisterData.getAlertTrendRegisterDataAssetDashboard(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault, (AlertTrendRegisterDataAssetDashboard, httpStatus) => {
      dispatch(AlertTrendRegisterDataUpdateAction({ data: AlertTrendRegisterDataAssetDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AlertTrendRegisterDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertTrendRegisterDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const fetchParameterTree = () => async (dispatch: any): Promise<void> => {
  dispatch(parameterTreeLoadingAction())
  void MenuInfoService.fetchSidebarMenuInfo(
    (menuInfoData, httpStatus) => {
      dispatch(parameterTreeUpdateAction({ data: menuInfoData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(parameterTreeErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const getFlameRegisterService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(flameRegisterGraphDataLoadingAction())
  try {
    await getModbusRegisterGraphService.getModbusRegisterLineData(startDate, endDate, graphName, requestParameter, isdefault, (flameRegisterAssetData, httpStatus) => {
      dispatch(flameRegisterGraphDataUpdateAction({ data: flameRegisterAssetData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(flameRegisterGraphDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(flameRegisterGraphDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getFlameKPIService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(flameKPIGraphDataLoadingAction())
  try {
    await getAssetPerformanceKPIData.getAssetPerformanceKPILineData(startDate, endDate, graphName, requestParameter, isdefault, (flameKPIAssetData, httpStatus) => {
      // Filter out data points where execution_status is "Failure"
      const filteredData = {
        ...flameKPIAssetData,
        deviceKPIReadings: flameKPIAssetData.deviceKPIReadings.map((device: any) => ({
          ...device,
          kpiReadings: device.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        })),
        assetKPIReadings: flameKPIAssetData.assetKPIReadings.map((asset: any) => ({
          ...asset,
          kpiReadings: asset.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        }))
      }
      dispatch(flameKPIGraphDataUpdateAction({ data: filteredData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(flameKPIGraphDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(flameKPIGraphDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getFlowRegisterService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(flowRegisterGraphDataLoadingAction())
  try {
    await getModbusRegisterGraphService.getModbusRegisterLineData(startDate, endDate, graphName, requestParameter, isdefault, (flowRegisterAssetData, httpStatus) => {
      dispatch(flowRegisterGraphDataUpdateAction({ data: flowRegisterAssetData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(flowRegisterGraphDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(flowRegisterGraphDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getFlowKPIService = (startDate: string, endDate: string, graphName: string, requestParameter: any, isdefault: boolean) => async (dispatch: any) => {
  dispatch(flowKPIGraphDataLoadingAction())
  try {
    await getAssetPerformanceKPIData.getAssetPerformanceKPILineData(startDate, endDate, graphName, requestParameter, isdefault, (flowKPIAssetData, httpStatus) => {
      // Filter out data points where execution_status is "Failure"
      const filteredData = {
        ...flowKPIAssetData,
        deviceKPIReadings: flowKPIAssetData.deviceKPIReadings.map((device: any) => ({
          ...device,
          kpiReadings: device.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        })),
        assetKPIReadings: flowKPIAssetData.assetKPIReadings.map((asset: any) => ({
          ...asset,
          kpiReadings: asset.kpiReadings.map((kpi: any) => ({
            ...kpi,
            kpiReadings: kpi.kpiReadings.filter((reading: any) => reading.execution_status !== 'Failure')
          }))
        }))
      }
      dispatch(flowKPIGraphDataUpdateAction({ data: filteredData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(flowKPIGraphDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(flowKPIGraphDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}
